import { report } from "./checks.ts";
import type { RulesProblem } from "./types.ts";

/**
 * The check that reads the attribute constants against one another (ADR-138 decision 2): each constant's own bounds are
 * its record's, and this runs across the constants after their records.
 */

/**
 * Checks that the attribute cap is at least the start, so a character's first values never stand above the cap. A
 * constant its own record refused is not compared.
 *
 * @param start The checked `attribute_start`, or null when the constants hold none that passed.
 * @param cap The checked `attribute_cap`, or null likewise.
 * @param problems Where problems go.
 */
export function checkAttributeCap(start: number | null, cap: number | null, problems: RulesProblem[]): void {
  if (start !== null && cap !== null && cap < start) {
    report({ table: "constants", id: "attribute_cap", problems }, `count is ${cap}, and it must be at least attribute_start, ${start}`);
  }
}
